import React, { useEffect, useState, useCallback } from "react";
import "./Header.css";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Select from "react-select";
import { FiSearch } from "react-icons/fi";

const backend = await new Backend().init();
const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: "20px",
    paddingLeft: "28px",
    border: "none",
    minHeight: "36px",
    backgroundColor: "var(--hover)", // ← bg theme
    boxShadow: "none",
    color: "var(--text)",
  }),

  placeholder: (base) => ({
    ...base,
    color: "var(--text)",
    opacity: 0.6,
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "var(--background)",
    overflow: "hidden",
    borderRadius: "12px",
    border: "2px solid var(--hover)", // <— your border
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // <— card shadow
    marginTop: "6px",
    padding: "4px",
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? "var(--primary)" : "transparent",
    color: isFocused ? "#fff" : "var(--text)",
    cursor: "pointer",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--text)",
  }),
  input: (base) => ({
    ...base,
    color: "var(--text)",
  }),
};
export default function Header({ master, updateType, userType, type }) {
  const [supers, setSupers] = useState([]);
  const [masters, setMasters] = useState([]);

  const [superFilter, setSuperFilter] = useState([]);
  const [masterFilter, setMasterFilter] = useState([]);

  const [superId, setSuperId] = useState(null);
  const [masterId, setMasterId] = useState(null);

  const [loading, setLoading] = useState(false);

  // Load filters
  useEffect(() => {
    if (userType === 1) loadSuperFilter();
    if (userType === 2) loadMasterFilter();
  }, [userType]);

  // Load Super List
  const loadSuperFilter = useCallback(async () => {
    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        admin_id: localStorage.getItem("id"),
      };

      const res = await backend.user_filter(data);
      if (res.error === "False") {
        setSupers(res.user);
        setSuperFilter(res.user);
      } else toast.error(res.message);
    } catch (e) {
      toast.error("Failed to load supers");
    }
    setLoading(false);
  }, []);

  // Load Masters
  const loadMasterFilter = useCallback(
    async (superId = null) => {
      setLoading(true);
      try {
        const data = {
          server: localStorage.getItem("server"),
          id: localStorage.getItem("id"),
          username: localStorage.getItem("username"),
          token: localStorage.getItem("token"),
          super_id: userType === 1 ? superId : localStorage.getItem("id"),
        };

        const res = await backend.user_filter(data);
        if (res.error === "False") {
          setMasters(res.user);
          setMasterFilter(res.user);
        } else toast.error(res.message);
      } catch (e) {
        toast.error("Failed to load masters");
      }
      setLoading(false);
    },
    [userType]
  );

  // Search filter
  const searchSuper = (txt) => {
    const q = txt.toLowerCase();
    setSupers(
      q.length > 1
        ? superFilter.filter((x) => x.username.toLowerCase().includes(q))
        : superFilter
    );
  };

  const searchMaster = (txt) => {
    const q = txt.toLowerCase();
    setMasters(
      q.length > 1
        ? masterFilter.filter((x) => x.username.toLowerCase().includes(q))
        : masterFilter
    );
  };

  const Clear = () => {
    setSuperId(null);
    setMasterId(null);
    master(null);
  };

  // Navigation
  const Create = () => updateType(0);
  const Summary = () => updateType(1);
  const User = () => updateType(2);

  return (
   <div className="h-[55px] bg-[var(--background)] items-center flex pr-4 pl-4">
      {/* LEFT BUTTONS */}
      <div className="UserLeft addHeaderFlex">
        <button
          onClick={Summary}
          className={`NavLinkBtn marginright ${
            type === 1 ? "selectlink" : "unselectlink"
          }`}
        >
          SUMMARY BROKER
        </button>

        <button
          onClick={User}
          className={`NavLinkBtn marginright ${
            type === 2 ? "selectlink" : "unselectlink"
          }`}
        >
          BROKER
        </button>
      </div>

      {/* RIGHT SIDE */}
      <div className="UserRight">
        {/* ============================= SUPER DROPDOWN ============================= */}
        {userType === 1 &&
          (superId ? (
            <button className="NavLinkBtn marginright unselectlink">
              SUPER : {superId.username}
            </button>
          ) : (
            <div className="relative mr-4 w-[240px]">
              <FiSearch
                className="absolute left-3 top-1/2 -translate-y-1/2 text-[18px] z-10"
                style={{ color: "var(--text)" }}
              />

              <Select
                placeholder={loading ? "Loading..." : "Select Super"}
                value={superId}
                onInputChange={searchSuper}
                onChange={(obj) => {
                  setSuperId(obj);
                  loadMasterFilter(obj.super_id);
                }}
                options={supers.map((s) => ({
                  value: s.id,
                  label: s.username,
                  ...s,
                }))}
                styles={customStyles}
                isSearchable
              />
            </div>
          ))}

        {/* ============================= MASTER DROPDOWN ============================= */}
        {(userType === 1 || userType === 2) &&
          (masterId ? (
            <button className="NavLinkBtn marginright unselectlink">
              MASTER : {masterId.username}
            </button>
          ) : (
            <div className="relative mr-2 w-[240px]">
              <FiSearch
                className="absolute left-3 top-1/2 -translate-y-1/2 text-[18px] z-10"
                style={{ color: "var(--text)" }}
              />

              <Select
                placeholder="Select Master"
                value={masterId}
                onInputChange={searchMaster}
                onChange={(obj) => {
                  setMasterId(obj);
                  master(obj.master_id);
                }}
                options={masters.map((m) => ({
                  value: m.id,
                  label: m.username,
                  ...m,
                }))}
                styles={customStyles}
                isSearchable
              />
            </div>
          ))}

        {/* CREATE USER BUTTON */}
        {(userType === 1 || userType === 2) && masterId && (
          <button
            onClick={Create}
            className="NavLinkBtn marginright unselectlink"
          >
            CREATE BROKER
          </button>
        )}

        {/* CLEAR BUTTON */}
        {(userType === 1 || userType === 2) && (superId || masterId) && (
          <button
            onClick={Clear}
            className="dropbtnNavSub sell marginright white"
          >
            CLEAR
          </button>
        )}

        {/* FOR USER TYPE 3 */}
        {userType === 3 && (
          <button
            onClick={Create}
            className="NavLinkBtn marginright unselectlink"
          >
            CREATE BROKER
          </button>
        )}
      </div>
    </div>
  );
}
